module.exports = __webpack_public_path__ + "static/txtling2-f2812285d362b6212dd667cc6dc8317d.png";